import configData from 'src/data';

export const getAppConfig = appName => {
  return configData.projects[appName];
};
